// Strážce session: zachytává 401 z API, hlídá heartbeatem expiraci
// a vyvolává event 'auth:session-expired', na který reaguje AuthManager
// vykreslením modálu pro obnovu přihlášení (bez ztráty rozpracované práce).

const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000; // 5 min
const HEARTBEAT_GRACE_MS = 30 * 1000; // po obnově nech 30 s bez heartbeatu

// Endpoints, které se nemají vyhodnocovat jako "session expired"
// (login sám o sobě vrací 401 při špatných údajích, check je interní heartbeat).
const AUTH_PASSTHROUGH_PATHS = ['/api/auth/login', '/api/auth/check'];

let installed = false;
let lastHeartbeatAt = 0;
let heartbeatTimer = null;

function isApiUrl(url) {
  if (!url) return false;
  try {
    const u = typeof url === 'string' ? url : url.url || '';
    if (u.startsWith('/api/')) return true;
    const parsed = new URL(u, window.location.href);
    return parsed.pathname.startsWith('/api/');
  } catch {
    return false;
  }
}

function isPassthrough(url) {
  if (!url) return false;
  try {
    const u = typeof url === 'string' ? url : url.url || '';
    return AUTH_PASSTHROUGH_PATHS.some((p) => u.includes(p));
  } catch {
    return false;
  }
}

function userLooksLoggedIn() {
  return Boolean(localStorage.getItem('currentUser'));
}

function emitSessionExpired(reason = 'unauthorized') {
  if (!userLooksLoggedIn()) return;
  window.dispatchEvent(new CustomEvent('auth:session-expired', { detail: { reason } }));
}

async function runHeartbeat() {
  if (!userLooksLoggedIn()) return;
  if (Date.now() - lastHeartbeatAt < HEARTBEAT_GRACE_MS) return;

  try {
    const res = await window.fetch('/api/auth/check', {
      method: 'GET',
      credentials: 'include',
    });
    if (res.status === 401) {
      emitSessionExpired('heartbeat');
    }
  } catch {
    // Síťová chyba není důvod uživatele otravovat – jen ignorujeme.
  } finally {
    lastHeartbeatAt = Date.now();
  }
}

export function noteSessionRestored() {
  lastHeartbeatAt = Date.now();
}

export function installSessionGuard() {
  if (installed) return;
  installed = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async function patchedFetch(input, init) {
    const response = await originalFetch(input, init);
    try {
      if (
        response.status === 401 &&
        isApiUrl(input) &&
        !isPassthrough(input) &&
        userLooksLoggedIn()
      ) {
        emitSessionExpired('api-401');
      }
    } catch {
      // Žádný interceptor by neměl shodit původní fetch.
    }
    return response;
  };

  // Heartbeat – periodicky a při probuzení tabu
  heartbeatTimer = window.setInterval(runHeartbeat, HEARTBEAT_INTERVAL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      runHeartbeat();
    }
  });
  window.addEventListener('focus', runHeartbeat);
}

export function stopSessionGuard() {
  if (heartbeatTimer) {
    window.clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
}
